import { atom } from "recoil";
import { IAlarmType } from "../types";

export const addStateAlarmType = atom({
  key: "addStateAlarmType",
  default: false,
});
export const editStateAlarmType = atom({
  key: "editStateAlarmType",
  default: false,
});
export const rowEditAlarmType = atom<IAlarmType | undefined>({
  key: "rowEditAlarmType",
  default: undefined,
});

export const selectedRowsStateAlarmType = atom<IAlarmType[]>({
  key: "selectedRowsStateAlarmType",
  default: [],
});

export const alarmTypeFilterText = atom({
  key: "alarmTypeFilterText",
  default: "",
});

export const alarmTypeFetching = atom({
  key: "alarmTypeFetching",
  default: true,
});
export const alarmTypeReFetching = atom({
  key: "alarmTypeReFetching",
  default: false,
});
